<template>
    <div class="footer">
        <!-- 繁体中文 -->
        <div class="footer-cn" v-if="lang=='zh-CN'">
            <div class="footer-row">
                <p>
                    <img :src="cdnPrefix+'/imgs/bekko.png'" class="logo" />
                    <img :src="cdnPrefix+'/imgs/sb.png'" class="sb" />
                </p>
            </div>
            <div class="footer-row">
                <p>{{$t("company.text1")}}</p>
            </div>
            <div class="footer-row">
                <p>{{$t("company.text2")}}</p>
            </div>
            <!-- <div class="footer-row">
                <p>{{$t("company.text5")}}</p>
            </div> -->
            <div class="footer-row">
                <p class="pptos">
                    <a href="https://www.bekko.com/#/Terms" target="_blank">{{$t("company.text3")}}</a>
                    <a href="https://www.bekko.com/#/Policy" target="_blank">{{$t("company.text4")}}</a>
                </p>
            </div>
            <div class="footer-row">
                <p>Copyright &nbsp;&nbsp;{{ new Date().getFullYear() }}&nbsp;&nbsp; Bekko Games</p>
            </div>
        </div>
        <!-- 日语 -->
        <div class="footer-ja" v-if="lang=='ja'">
            <div class="footer-row">
                <p class="pptos">
                    <span>{{$t("company.text1")}}</span>
                    <span>{{$t("company.text2")}}</span>
                </p>
            </div>
            <div class="footer-row">
                <p class="footer-link">
                    <a
                        href="https://sengoku.bekko.com/#/new_detail?nid=29"
                        target="_blank"
                    >{{$t("company.text3")}}</a>
                    <span>|</span>
                    <a
                        href="http://www.jedi-games.com/company/policy.html?lang=4"
                        target="_blank"
                    >{{$t("company.text4")}}</a>
                    <span>|</span>
                    <a
                        href="https://sengoku.bekko.com/#/new_detail?nid=30"
                        target="_blank"
                    >{{$t("company.text5")}}</a>
                    <span>|</span>
                    <a
                        href="https://sengoku.bekko.com/#/new_detail?nid=31"
                        target="_blank"
                    >{{$t("company.text7")}}</a>
                </p>
            </div>
            <div class="footer-row">
                <p>
                    <a href="https://www.bekko.com">
                        <img :src="cdnPrefix+'/imgs/bekko.png'" class="logo" />
                    </a>
                </p>
            </div>
        </div>
        <!-- 英文 -->
        <div class="footer-en" v-if="lang=='en'">
            <div class="footer-row">
                <p>
                    <a href="https://www.bekko.com">
                        <img :src="cdnPrefix+'/imgs/bekko.png'" class="logo" />
                    </a>
                </p>
            </div>
            <div class="footer-row">
                <p class="pptos">
                    <a href="https://www.bekko.com/#/Terms" target="_blank">{{$t("company.text1")}}</a>
                    <a href="https://www.bekko.com/#/Policy" target="_blank">{{$t("company.text2")}}</a>
                </p>
            </div>
            <div class="footer-row">
                <p>Copyright &nbsp;&nbsp;{{ new Date().getFullYear() }}&nbsp;&nbsp; Bekko Games</p>
            </div>
        </div>
        <!-- 泰语 -->
        <div class="footer-th" v-if="lang=='th'">
            <div class="footer-row">
                <a href="https://www.bekko.com">
                    <b>Bekko Games</b>
                </a>
            </div>
            <div class="footer-row" style="margin:20px 0;">
                <b>โปรดเล่นให้เป็นเวลา และรักษาสุขภาพ</b>
            </div>
            <div class="footer-row">
                <p>
                    <img :src="cdnPrefix+'/imgs/bekko.png'" class="logo" />
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Footer",
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            lang: window.localStorage.getItem("localeLanguage") || "zh-CN"
        };
    },
    computed: {},
    watch: {},
    mounted() {},
    methods: {
        download_fb() {
            alert("fb");
        },
        download_bird() {
            alert("bird");
        }
    }
};
</script>

<style lang="scss">
.footer {
    width: 100%;
    background: #4f251b;
    padding: 20px;
    color: #fff;
    .footer-row {
        display: flex;
        justify-content: center;
        p {
            text-align: center;
            margin: 5px 0;
            .logo,
            .sb {
                height: 50px;
                margin: 0 20px;
            }
        }
        .pptos {
            width: 100%;
            display: flex;
            justify-content: center;
            span {
                margin: 0 3.3%;
            }
            a {
                margin: 0 3.3%;
                color: #fff;
                text-decoration: none;
            }
        }
    }
    .footer-ja {
        .footer-row {
            .footer-link {
                width: 100%;
                max-width: 1000px;
                text-align: center;
                margin: 40px 0 20px;
                a {
                    display: inline-block;
                    color: #fff;
                    text-decoration: none;
                }
                span {
                    display: inline-block;
                    padding: 0 2%;
                }
            }
        }
    }
    .footer-th {
        color: #fff;
        a {
            color: #fff;
        }
    }
}
@media screen and (max-width: 768px) {
    .footer {
        .footer-ja {
            .footer-row {
                .pptos {
                    display: flex;
                    flex-direction: column;
                    margin: 0;
                    span {
                        margin: 5px 0;
                    }
                }
                .footer-link {
                    margin: 20px 0;
                }
            }
        }
    }
}
@media screen and (max-width: 414px) {
    .footer {
        font-size: 12px;
        .footer-ja {
            .footer-row {
                .pptos {
                    margin: 0;
                    span {
                        margin: 0;
                    }
                }
                .footer-link {
                    margin: 10px 0;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue